module.exports = __webpack_public_path__ + "static/index/img/baikal-607.d47d9689.jpg";